export { default as useDeepEffect } from './use-deep-effect';
